import React, {useEffect, useState} from 'react';
import {DragDropContext} from 'react-beautiful-dnd';
import {Col, Divider, Row} from 'antd';
import DroppableArea from './DroppableArea';

const defPivot = {x: [], y: []}

export default function Axes({
  pivotConfig,
  onMove
}) {
  console.log("pic-cfg", pivotConfig)
  const [uiPivotConfig, setUIPivotConfig] = useState(pivotConfig || defPivot );
  console.log("uif-cfg", uiPivotConfig)

  useEffect(() => {
    setUIPivotConfig(pivotConfig || defPivot);
  }, [pivotConfig]);
  return <DragDropContext onDragEnd={({
    source,
    destination,
    ...props
  }) => {
    if (!destination) {
      return;
    }

    onMove({
      sourceIndex: source.index,
      destinationIndex: destination.index,
      sourceAxis: source.droppableId,
      destinationAxis: destination.droppableId,

      callback(updatedPivotConfig) {
        setUIPivotConfig(updatedPivotConfig || defPivot);
      }

    });
  }}>
      <Row>
        <Col span={11}>
          <DroppableArea pivotConfig={uiPivotConfig} axis="x" />
        </Col>

        <Col span={2}>
          <Divider style={{
          height: '100%'
        }} type="vertical" />
        </Col>

        <Col span={11}>
          <DroppableArea pivotConfig={uiPivotConfig} axis="y" />
        </Col>
      </Row>
    </DragDropContext>;
}